function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "c07350d9-0c50-4d35-b63a-3c71f5ac29f1",
  x1: 304.32,
  y1: 452.8,
  x2: 304.32,
  y2: 148.23,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "gray",
  stopOpacity: 0.25
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.54,
  stopColor: "gray",
  stopOpacity: 0.12
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "gray",
  stopOpacity: 0.1
})));

var _ref3 = /*#__PURE__*/React.createElement("title", null, "broadcast");

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M847.51,148.64a84.83,84.83,0,0,1,31.57,57.89,6.66,6.66,0,0,0,6.82,6l10.24-.3a6.68,6.68,0,0,0,6.46-7.31,108.65,108.65,0,0,0-113.2-98.3,6.69,6.69,0,0,0-6.34,7.42l1.14,10.18a6.65,6.65,0,0,0,6.85,5.92A84.79,84.79,0,0,1,847.51,148.64Z",
  transform: "translate(-297.37 -69.26)",
  fill: "#005aaa"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M839.34,158.88a84.78,84.78,0,0,0-55.4-18.56,6.67,6.67,0,0,0-6.42,7.42l.85,7.59a6.66,6.66,0,0,0,6.74,5.92,64.15,64.15,0,0,1,64.79,56.22,6.68,6.68,0,0,0,6.81,5.89l7.63-.22a6.66,6.66,0,0,0,6.45-7.37A84.82,84.82,0,0,0,839.34,158.88Z",
  transform: "translate(-297.37 -69.26)",
  fill: "#005aaa"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M807.48,198.8a47,47,0,0,1,17.15,29.52,6.73,6.73,0,0,0,6.81,5.77l3.69-.11a6.69,6.69,0,0,0,6.41-7.69,64.15,64.15,0,0,0-63.32-54.82,6.64,6.64,0,0,0-6.52,7.42l.41,3.68a6.73,6.73,0,0,0,6.67,5.93A46.94,46.94,0,0,1,807.48,198.8Z",
  transform: "translate(-297.37 -69.26)",
  fill: "#005aaa"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M352.49,148.64a84.83,84.83,0,0,0-31.57,57.89,6.66,6.66,0,0,1-6.82,6l-10.24-.3a6.68,6.68,0,0,1-6.46-7.31,108.65,108.65,0,0,1,113.2-98.3,6.69,6.69,0,0,1,6.34,7.42L415.8,124.2a6.65,6.65,0,0,1-6.85,5.92A84.79,84.79,0,0,0,352.49,148.64Z",
  transform: "translate(-297.37 -69.26)",
  fill: "#005aaa"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M360.66,158.88a84.78,84.78,0,0,1,55.4-18.56,6.67,6.67,0,0,1,6.42,7.42l-.85,7.59a6.66,6.66,0,0,1-6.74,5.92,64.15,64.15,0,0,0-64.79,56.22,6.68,6.68,0,0,1-6.81,5.89l-7.63-.22a6.66,6.66,0,0,1-6.45-7.37A84.82,84.82,0,0,1,360.66,158.88Z",
  transform: "translate(-297.37 -69.26)",
  fill: "#005aaa"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M392.52,198.8a47,47,0,0,0-17.15,29.52,6.73,6.73,0,0,1-6.81,5.77l-3.69-.11a6.69,6.69,0,0,1-6.41-7.69,64.15,64.15,0,0,1,63.32-54.82,6.64,6.64,0,0,1,6.52,7.42l-.41,3.68a6.73,6.73,0,0,1-6.67,5.93A46.94,46.94,0,0,0,392.52,198.8Z",
  transform: "translate(-297.37 -69.26)",
  fill: "#005aaa"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M577.93,822.91V88.25a19,19,0,0,1,19-19h11.26a19,19,0,0,1,19,19V822.91C627.17,833.35,577.93,833.35,577.93,822.91Z",
  transform: "translate(-297.37 -69.26)",
  fill: "#535461"
});

var _ref11 = /*#__PURE__*/React.createElement("rect", {
  x: 120.96,
  y: 148.23,
  width: 366.73,
  height: 304.56,
  rx: 44.36,
  ry: 44.36,
  fill: "url(#c07350d9-0c50-4d35-b63a-3c71f5ac29f1)"
});

var _ref12 = /*#__PURE__*/React.createElement("rect", {
  x: 125.44,
  y: 152.71,
  width: 358.31,
  height: 295.61,
  rx: 44.36,
  ry: 44.36,
  fill: "#fff"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M618.47,344.61a4.76,4.76,0,0,1,4.75,4.75v40.83a4.76,4.76,0,0,1-4.75,4.75H581.53a4.76,4.76,0,0,1-4.75-4.75V349.36a4.76,4.76,0,0,1,4.75-4.75h36.95m0-2H581.53a6.75,6.75,0,0,0-6.75,6.75v40.83a6.75,6.75,0,0,0,6.75,6.75h36.95a6.75,6.75,0,0,0,6.75-6.75V349.36a6.75,6.75,0,0,0-6.75-6.75Z",
  transform: "translate(-297.37 -69.26)",
  fill: "#e0e0e0"
});

var _ref14 = /*#__PURE__*/React.createElement("line", {
  x1: 302.63,
  y1: 288.42,
  x2: 302.63,
  y2: 299.88,
  fill: "none",
  stroke: "#005aaa",
  strokeLinecap: "round",
  strokeMiterlimit: 10,
  strokeWidth: 2
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M604.8,362.7a10.19,10.19,0,1,1-9.42-.09",
  transform: "translate(-297.37 -69.26)",
  fill: "none",
  stroke: "#005aaa",
  strokeLinecap: "round",
  strokeMiterlimit: 10,
  strokeWidth: 2
});

var SvgLogo2 = function SvgLogo2(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "38cdf2ff-2938-440d-a9ba-a7e55f8599a6",
    "data-name": "Layer 1",
    width: 605.25,
    height: 761.48,
    viewBox: "0 0 605.25 761.48",
    ref: svgRef
  }, props), _ref2, title === undefined ? _ref3 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogo2, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logo_2.a8bc9e48.svg";
export { ForwardRef as ReactComponent };